// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Belt_MapString = require("bs-platform/lib/js/belt_MapString.js");
var BeltHoles_Result = require("belt-holes/src/BeltHoles_Result.bs.js");
var Either$XodFuncTools = require("xod-func-tools/src/Either.bs.js");

function getLivenessString(liveness) {
  switch (liveness) {
    case /* None */0 :
        return "NONE";
    case /* Debug */1 :
        return "DEBUG";
    case /* Simulation */2 :
        return "SIMULATION";
    
  }
}

function transpile(project, patchPath, liveness, xodGlobals) {
  return BeltHoles_Result.map(Either$XodFuncTools.toResult($dot$dot.transformProject(project, patchPath, getLivenessString(liveness), xodGlobals)), (function (tProject) {
                return {
                        code: $dot$dot.transpile(tProject),
                        nodeIdMap: Belt_MapString.fromArray(Js_dict.entries($dot$dot.getNodeIdsMap(tProject)))
                      };
              }));
}

exports.transpile = transpile;
/* .. Not a pure module */



//////////////////
// WEBPACK FOOTER
// ../xod-arduino/src/Transpiler.bs.js
// module id = 1485
// module chunks = 0